import React, { useEffect, useState } from "react";
import "./headerweb.css";
import { Button, Input } from "antd";
import facebook from "../../../assets/facebook.png";
import instagram from "../../../assets/insta.png";
import youtube from "../../../assets/youtube.png";

import { API } from "../../../config/api";
import { GET } from "../../../utils/apicalls";
import { useNavigate } from "react-router-dom";

const Header: React.FC = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [isSticky, setIsSticky] = useState(false);
  const [data, setData] = useState<any>([]);
  const navigate = useNavigate();

  const [categoryData, setCategoryData] = useState<any>([]);


  const fetchcontactinformation = async () => {
    try {
      setIsLoading(true);
      let api = API.LIST_CONTACT_INFORMATION;
      const response: any = await GET(api, {});

      console.log("API Response:", response); // Debugging response
      setData(response?.data?.[0] || {}); // Store the first object
    } catch (error) {
      console.error("Error fetching contact information:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchcontactinformation();
  }, []);
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setIsSticky(true);
      } else {
        setIsSticky(false);
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const fetchCategories = async () => {
    try {
      setIsLoading(true);
      const response: any = await GET(API.LISTING_GET_CATEGORY, {});
      setCategoryData(response?.data || []);
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchCategories();
  }, []);
  const [isOpen, setIsOpen] = useState(false);

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  const [query, setQuery] = useState("");
  const [productData, setProductData] = useState<any[]>([]);


  // Fetch products
  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const response: any = await GET(API.PRODUCT_GET_LISTING, {});
        setProductData(response?.data || []);
      } catch (error) {
        console.error(error);
      }
    };

    fetchProducts();
  }, []);

  // Handle search
  const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    setQuery(e.target.value.toLowerCase());
  };

  // Handle product selection
  const handleSelectProduct = (productTitle: string) => {
    const selectedProduct = productData.find(
      (product) => product?.productTitle?.toLowerCase() === productTitle
    );

    if (selectedProduct) {
      navigate(`/product/${selectedProduct.id}`); // Redirects to product details page
    }
  };
  return (
    <div>
      {/* Top Bar */}
      <div className="top-bar">
        <div className="top-links">
          <span><a href="/Contact" style={{ color: "white" }}>FAQ</a></span> |
          <span><a href="/Contact" style={{ color: "white" }}>Help Desk</a></span>
        </div>
        <div className="social-icons">
          <ul>
            <li>
              <a href={data?.faceBookLink} target="_blank" rel="noopener noreferrer">
                <img src={facebook} alt="Facebook" />
              </a>
            </li>
            <li>
              <a href={data?.instaLink} target="_blank" rel="noopener noreferrer">
                <img src={instagram} alt="Instagram" />
              </a>
            </li>
            <li>
              <a href={data?.youtubeLink} target="_blank" rel="noopener noreferrer">
                <img src={youtube} alt="YouTube" />
              </a>
            </li>
          </ul>
        </div>
      </div>

      {/* Main Header */}
      <div className="main-header">
        <div className="logo">
          <img src="/logo.png" alt="MJ Speed Track" />
        </div>
        <br />
        <div className="search-bar">
          <Input
            type="text"
            placeholder="Search for a product..."
            value={query}
            onChange={handleSearch}
            onPressEnter={() => handleSelectProduct(query)} // Press Enter to go to product
          />
          <div className="search-results">
            {query &&
              productData
                .filter((product) =>
                  product?.productTitle?.toLowerCase().includes(query)
                )
                .slice(0, 5) // Show only top 5 results
                .map((product) => (
                  <div
                    key={product.id}
                    className="search-result-item"
                    onClick={() => handleSelectProduct(product.productTitle)}
                  >
                    {product.productTitle}
                  </div>
                ))}
          </div>
        </div>


      </div>
      <header className={`header-nav-wrapper ${isSticky ? "sticky" : ""}`}>
        <div className="kp-header" onClick={() => setMenuOpen(!menuOpen)}>
          <Button href="/" className="kp-nav-link">Home</Button>
          <Button href="/client" className="kp-nav-link">Client Login</Button>
          <span className="kp-toggle-icon">{menuOpen ? "✖" : "☰"}</span>
        </div>


        <nav className={`nav-bar ${menuOpen ? "open" : ""}`}>

          {/* Close Icon - shows only when menu is open */}
          {menuOpen && (
            <span className="close-icon" onClick={() => setMenuOpen(false)}>
              ✖
            </span>
          )}

          <ul>
            <li><a href="/" className="nav-link">Home</a></li>
            <li><a href="/about" className="nav-link">About</a></li>
            <li><a href="/product" className="nav-link">Products</a></li>

            <li className="nav-item dropdown">
              <a href="#" className="nav-link" onClick={toggleDropdown}>
                Category <span className="arrow">{isOpen ? "▲" : "▼"}</span>
              </a>

              {isOpen && (
                <ul className="dropdown-menu">
                  {isLoading ? (
                    <li>Loading...</li>
                  ) : categoryData.length > 0 ? (
                    categoryData.map((category: any) => (
                      <li key={category.id}>
                        <a href={`/category/${category.id}`}>{category.categoryTitle}</a>
                      </li>
                    ))
                  ) : (
                    <li>No categories found</li>
                  )}
                </ul>
              )}
            </li>

            <li><a href="/contact" className="nav-link">Contact</a></li>

            <hr style={{ backgroundColor: "red" }} />

            <li>
              <Button
                className="book-now"
                onClick={() => navigate(`/product`)}
              >
                Book Now
              </Button>
            </li>
          </ul>
        </nav>

      </header>

    </div>
  );
};

export default Header;
